// extracted by mini-css-extract-plugin
export default {"cardArticle":"style-module--cardArticle--HXJXF"};